import { Component, Input, Output } from '@angular/core';
import { ConditionEnumOption, ConditionVariable } from '@tytapp/content';
import { Subject } from 'rxjs';

@Component({
    selector: 'tyt-condition-value-editor',
    templateUrl: './condition-value-editor.component.html',
    styleUrl: './condition-value-editor.component.scss',
    standalone: false
})
export class ConditionValueEditorComponent {
    @Input() type: string;
    @Input() enumOptions: ConditionEnumOption[];
    @Input() value: any;
    @Output() valueChange = new Subject<any>();
}